module.exports = __webpack_public_path__ + "static/img/member260112EN.ce3af14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/member260112EN.jpg
// module id = 8zZ1
// module chunks = 1